import { Money } from './money-model';
export class CardOffer {

  limit: Money;

  constructor() {
    this.limit = new Money();
  }
}
